const PX_TO_REM_RATIO = 0.02;

export { PX_TO_REM_RATIO };
